/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents the eligibility status of a client profile.
 */
export const ClientEligibilityStatus = {
    Pending: 0,
    Eligible: 1,
    NotEligible: 2
} as const;
export type ClientEligibilityStatus = typeof ClientEligibilityStatus[keyof typeof ClientEligibilityStatus];

